import { useState, useCallback } from "react";
import { getSubproductosEntidad } from "../../../services/SubproductoService.js";

const useSubproductos = (baseUrl, empresa, toast) => {
  const [subproductos, setSubproductos] = useState([]);
  const [loadingInicial, setLoadingInicial] = useState(false);

  const fetchData = useCallback(async () => {
    setLoadingInicial(true);
    try {
      const data = await getSubproductosEntidad(baseUrl, empresa);
      setSubproductos(data);
    } catch (error) {
      console.error("Error al obtener los subproductos:", error);
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.message || "No se pudieron obtener los subproductos",
        life: 3000,
      });
    } finally {
      setLoadingInicial(false);
    }
  }, [baseUrl, empresa, toast]);

  return { subproductos, setSubproductos, loadingInicial, fetchData };
};

export default useSubproductos;
